import React from "react";
import PropTypes from "prop-types";
import LabelTextInput from "../LabelTextInput";
import { Button, Flex, Text } from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";
import { CallIcon } from "@fluentui/react-icons-northstar";

const CallNumber = (props) => {
  const {
    onCallNumberChanged,
    onCallButtonClicked,
    disableInput,
    disableButton,
    number,
    wrapUpShowWarning,
  } = props;

  return (
    <Flex column>
      <Flex className="call-number-flex" vAlign="end" gap="gap.small" hAlign="stretch" fill>
        <LabelTextInput
          label={Constants.CALL}
          placeholder={Constants.ENTER_NUMBER_PLACEHOLDER}
          testId="callNumber"
          className="call-number"
          onChange={onCallNumberChanged}
          disabled={disableInput}
          value={number ? number : ""}
        />
        <Button
          data-testid="callNumberButton"
          primary
          onClick={onCallButtonClicked}
          content={Constants.CALL}
          icon={<CallIcon />}
          disabled={disableButton}
        />
      </Flex>
      <Text
        data-testid="wrapUpWarning"
        size="small"
        className="wrap-up-warning" >
        {wrapUpShowWarning ? Constants.WRAP_UP_WARNING : null}
      </Text>
    </Flex>
  );
};

CallNumber.propTypes = {
  number: PropTypes.string,
  disableButton: PropTypes.bool,
  disableInput: PropTypes.bool,
  onCallNumberChanged: PropTypes.func,
  onCallButtonClicked: PropTypes.func,
};

CallNumber.defaultProps = {
  number: "",
  disableButton: false,
  disableInput: false,
};

export default CallNumber;
